import React, { useState } from "react";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useParams } from "react-router-dom";

import { CustomerProvider } from "@app/contexts/CustomerContext";
import { DossierProvider } from "@app/contexts/DossierContext";
import CustomerContent from "@app/components/3_modules/CustomerContent";

export default function CustomerEdit() {
    const [loaded, setLoaded] = useState(false);
    const [dossier, setDossier] = useState(null);
    const [customer, setCustomer] = useState(null);
    
    const auth = useAuth();
    
    const { id } = useParams();

    if (!loaded) {
        getCustomer(id);
    }
    
    function getCustomer(customer_id) {
        apiCall ({
            method: "get",
            path: `/api/v1/customers/${customer_id}`,
            auth: auth,
            onSuccess: (response) => {
                const data = response.data.customer;

                setLoaded(true);    
                setCustomer(data);
                
                const dossierId = data.dossiers[0].id;
                getDossier(dossierId)
            }
        });
    }

    function getDossier(dossier_id) {
        apiCall ({
            method: "get",
            path: `/api/v1/dossiers/${dossier_id}`,
            auth: auth,
            onSuccess: (response) => {
                setDossier(response.data.dossier);
            }
        });
    }
    
    if (!customer || !dossier)
        return;

    return (
        <CustomerProvider defaultCustomer={customer}>                
            <DossierProvider defaultDossier={dossier}>
                <CustomerContent />                    
            </DossierProvider>                
        </CustomerProvider>
    )
}